import { handleActions } from 'redux-actions';

import {
  FETCH_RESULTS,
  FETCH_RESULT,
  FETCH_GAME_EVENTS,
  FETCH_GAME_CONVERSATIONS,
  RESULTS_FILTER_SET,
  RESULTS_PAGE_SET
} from '../../constants/Constants';

const initialState = { items: [], filter: null, pagination: { page: 0, size: 50 }, currentResult: {} };

export default handleActions(
  {
    [FETCH_RESULTS.SUCCESS]: (state, { payload: { items, page } }) => ({
      ...state,
      items,
      page
    }),
    [FETCH_RESULT.SUCCESS]: (state, { payload: { payload } }) => ({ ...state, currentResult: payload }),
    [FETCH_GAME_EVENTS.SUCCESS]: (state, { payload: { items } }) => ({
      ...state,
      currentResult: { ...state.currentResult, events: items }
    }),
    [FETCH_GAME_CONVERSATIONS.SUCCESS]: (state, { payload: { items } }) => ({
      ...state,
      currentResult: { ...state.currentResult, conversations: items }
    }),
    [RESULTS_PAGE_SET]: (state, { payload: { page } }) => ({ ...state, pagination: { ...state.pagination, page } }),
    [RESULTS_FILTER_SET]: (state, { payload }) => ({ ...state, filter: payload })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/entities/ResultsReducer.js